/* eslint linebreak-style: ["error", "unix"] */
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { selectCurrentUser } from 'redux/auth.redux';
import { APP_ROUTES } from 'data/app';
import { isSubscriber } from 'data/subscriptions';
import { UserRole } from 'data/users';
import { RouteProps } from './routes.interfaces';

interface Props extends RouteProps { }

export default function SubscriberRoute({ component, ...rest }: Props) {
  const user = useSelector(selectCurrentUser);

  // Allow admins to access subscriber routes
  if (user?.role === UserRole.ADMIN) {
    return <Route {...rest} component={component} />;
  }

  // If no user or no subscription active, redirect to home
  if (!user || !isSubscriber(user)) {
    return <Redirect to={APP_ROUTES.home} />;
  }

  // User is subscriber, allow route
  return <Route {...rest} component={component} />;
}
